import { ApiProperty } from '@nestjs/swagger';
import { IsOptional, IsNumber, IsBoolean } from 'class-validator';
export class UpdateVehicleStatusRequest {
   @ApiProperty()
    @IsOptional()
    @IsNumber() 
    indentId: number;
   @ApiProperty()
    @IsOptional()
    @IsBoolean() 
    vehicleAssigned: boolean;
}